import React from 'react';
import { FadeInView } from '../ui/FadeInView';
import { CTAButton } from '../ui/CTAButton';
export function BonusPricingSection() {
  return <section id="compra" className="py-16 md:py-24 px-4 bg-[#FAF7F2] text-center scroll-mt-10 relative overflow-hidden" data-id="element-11">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-12">
        <FadeInView data-id="element-13">
          {/* URGENCY BLOCK */}
          <div className="mb-16 bg-red-50 border-2 border-red-200 rounded-3xl p-8 md:p-10" data-id="element-14">
            <h2 className="text-3xl md:text-5xl font-bold text-red-600 mb-6 leading-tight" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-15">
              🔴 ATENCIÓN — ESTO NO DURA PARA SIEMPRE
            </h2>

            <p className="text-xl md:text-2xl text-[#1B4332] mb-6 font-medium" data-id="element-16">
              Esta es una oferta de lanzamiento.
            </p>

            <p className="text-lg text-[#2D5016]/80 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-17">
              El precio actual existe porque estamos en fase de lanzamiento.
              Cuando esta fase termine el precio sube y no vuelve a bajar.
            </p>

            <p className="text-base text-[#1B4332]/70 mb-8 italic" data-id="element-18">
              No es un truco de marketing. Es la realidad de cómo funcionan
              nuestros lanzamientos.
            </p>

            <div className="space-y-3 text-lg font-bold text-red-600" data-id="element-19">
              <p data-id="element-20">🔴 Las plazas al precio de lanzamiento son limitadas</p>
              <p data-id="element-21">🔴 El 68% de los cupos ya han sido tomados</p>
              <p data-id="element-22">🔴 Cuando se acaben — el precio sube</p>
            </div>

            <p className="text-base text-[#2D5016]/70 mt-8 italic" data-id="element-23">
              Puedes cerrar esta página y volver mañana. Pero mañana esto ya no
              estará al mismo precio.
            </p>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-[#1B4332] mb-12 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-24">
            Elige tu pack:
          </h2>

          {/* TWO PRICING OPTIONS */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-25">
            {/* OPTION 1 - MEGAPACK BASE */}
            <div className="bg-[#F5F0E8] rounded-3xl p-8 md:p-10 border border-[#D4A853]/20 shadow-sm" data-id="element-26">
              <h3 className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-4" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-27">
                OPCIÓN 1 — MEGAPACK BASE
              </h3>
              <p className="text-lg text-[#2D5016] mb-6 font-medium" data-id="element-28">
                6 Libros + 3 Bonos Estratégicos
              </p>

              <div className="text-left space-y-3 mb-8 text-base text-[#1B4332]" data-id="element-29">
                <p className="flex items-start gap-2" data-id="element-30">
                  <span className="text-[#D4A853]" data-id="element-31">✅</span>
                  <span data-id="element-32">Libro 1 — Cómo Adelgazar con Air Fryer</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-33">
                  <span className="text-[#D4A853]" data-id="element-34">✅</span>
                  <span data-id="element-35">Libro 2 — Recetas del Día a Día</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-36">
                  <span className="text-[#D4A853]" data-id="element-37">✅</span>
                  <span data-id="element-38">Libro 3 — Planifica tus Comidas</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-39">
                  <span className="text-[#D4A853]" data-id="element-40">✅</span>
                  <span data-id="element-41">Libro 4 — Batch Cooking con Air Fryer</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-42">
                  <span className="text-[#D4A853]" data-id="element-43">✅</span>
                  <span data-id="element-44">Libro 5 — Postres sin Culpa</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-45">
                  <span className="text-[#D4A853]" data-id="element-46">✅</span>
                  <span data-id="element-47">Libro 6 — Sin Efecto Rebote</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-48">
                  <span className="text-[#D4A853]" data-id="element-49">✅</span>
                  <span data-id="element-50">Bono 1 — Plan Semanal Completo</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-51">
                  <span className="text-[#D4A853]" data-id="element-52">✅</span>
                  <span data-id="element-53">Bono 2 — Guía de Cocción Air Fryer</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-54">
                  <span className="text-[#D4A853]" data-id="element-55">✅</span>
                  <span data-id="element-56">Bono 3 — Lista de la Compra Mensual</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-57">
                  <span className="text-[#D4A853]" data-id="element-58">✅</span>
                  <span data-id="element-59">Acceso inmediato en PDF</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-60">
                  <span className="text-[#D4A853]" data-id="element-61">✅</span>
                  <span data-id="element-62">Garantía 7 días sin preguntas</span>
                </p>
              </div>

              <div className="mb-6" data-id="element-63">
                <p className="text-sm text-[#1B4332]/50 line-through mb-2" data-id="element-64">
                  Valor real: 49,00€
                </p>
                <p className="text-5xl font-bold text-[#2D5016]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-65">
                  16,99€
                </p>
              </div>

              <CTAButton href="https://pagos.digipromarket.com/cart/56222402937158:1" text="→ QUIERO EL MEGAPACK BASE" data-id="element-66" />
            </div>

            {/* OPTION 2 - PACK COMPLETO + AIR-FAST 7 */}
            <div className="bg-gradient-to-b from-[#1B4332] to-[#2D5016] rounded-3xl p-8 md:p-10 border-2 border-[#D4A853] shadow-2xl relative" data-id="element-67">
              {/* Badge */}
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#D4A853] text-[#1B4332] font-bold px-6 py-2 rounded-full text-sm tracking-widest uppercase shadow-md whitespace-nowrap" data-id="element-68">
                ⭐ LA MÁS ELEGIDA
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-[#D4A853] mb-4 mt-4" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-69">
                🏆 OPCIÓN 2 — PACK COMPLETO + AIR‑FAST 7
              </h3>
              <p className="text-lg text-[#FAF7F2] mb-6 font-medium" data-id="element-70">
                6 Libros + 3 Bonos + Sistema de Aceleración AIR‑FAST 7
              </p>

              <div className="text-left space-y-3 mb-8 text-base text-[#FAF7F2]" data-id="element-71">
                <p className="flex items-start gap-2" data-id="element-72">
                  <span className="text-[#D4A853]" data-id="element-73">✅</span>
                  <span data-id="element-74">Todo lo del MegaPack Base</span>
                </p>
                <p className="flex items-start gap-2 bg-[#FAF7F2]/10 p-3 rounded-xl" data-id="element-75">
                  <span className="text-[#D4A853]" data-id="element-76">✅</span>
                  <span className="font-bold" data-id="element-77">
                    Sistema AIR‑FAST 7 — El programa de 21 días para acelerar
                    resultados
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-78">
                  <span className="text-[#D4A853]" data-id="element-79">✅</span>
                  <span data-id="element-80">Plan de aceleración semana a semana</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-81">
                  <span className="text-[#D4A853]" data-id="element-82">✅</span>
                  <span data-id="element-83">Recetas específicas del programa AIR‑FAST 7</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-84">
                  <span className="text-[#D4A853]" data-id="element-85">✅</span>
                  <span data-id="element-86">Guía de hábitos de los 21 días</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-87">
                  <span className="text-[#D4A853]" data-id="element-88">✅</span>
                  <span data-id="element-89">Acceso inmediato en PDF</span>
                </p>
                <p className="flex items-start gap-2" data-id="element-90">
                  <span className="text-[#D4A853]" data-id="element-91">✅</span>
                  <span data-id="element-92">Garantía 7 días sin preguntas</span>
                </p>
              </div>

              <div className="mb-6" data-id="element-93">
                <p className="text-sm text-[#FAF7F2]/50 line-through mb-2" data-id="element-94">
                  Valor real: 78,00€
                </p>
                <p className="text-5xl font-bold text-[#D4A853]" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-95">
                  23,99€
                </p>
              </div>

              <a href="https://pagos.digipromarket.com/cart/56222886723910:1" className="block w-full bg-[#D4A853] hover:bg-[#B8935C] text-[#1B4332] font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-sm text-center cursor-pointer transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]" data-id="element-96">
                → QUIERO EL PACK COMPLETO CON AIR‑FAST 7
              </a>
            </div>
          </div>

          {/* COMPARISON TABLE */}
          <div className="mb-16" data-id="element-97">
            <h3 className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-8" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-98">
              💡 ¿POR QUÉ EL PACK COMPLETO ES LA OPCIÓN MÁS INTELIGENTE?
            </h3>

            <div className="bg-[#F5F0E8] rounded-2xl p-6 md:p-8 border border-[#D4A853]/20 shadow-sm overflow-x-auto" data-id="element-99">
              <table className="w-full text-left" data-id="element-100">
                <thead data-id="element-101">
                  <tr className="border-b-2 border-[#D4A853]/30" data-id="element-102">
                    <th className="py-4 px-4 text-[#1B4332] font-bold" data-id="element-103"></th>
                    <th className="py-4 px-4 text-[#1B4332] font-bold text-center" data-id="element-104">
                      MegaPack Base
                    </th>
                    <th className="py-4 px-4 text-[#D4A853] font-bold text-center" data-id="element-105">
                      Pack Completo + AIR‑FAST 7
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#D4A853]/10" data-id="element-106">
                  <tr data-id="element-107">
                    <td className="py-3 px-4 text-[#1B4332]" data-id="element-108">
                      6 Libros del sistema
                    </td>
                    <td className="py-3 px-4 text-center" data-id="element-109">✅</td>
                    <td className="py-3 px-4 text-center" data-id="element-110">✅</td>
                  </tr>
                  <tr data-id="element-111">
                    <td className="py-3 px-4 text-[#1B4332]" data-id="element-112">
                      3 Bonos estratégicos
                    </td>
                    <td className="py-3 px-4 text-center" data-id="element-113">✅</td>
                    <td className="py-3 px-4 text-center" data-id="element-114">✅</td>
                  </tr>
                  <tr data-id="element-115">
                    <td className="py-3 px-4 text-[#1B4332]" data-id="element-116">
                      Sistema AIR‑FAST 7
                    </td>
                    <td className="py-3 px-4 text-center" data-id="element-117">❌</td>
                    <td className="py-3 px-4 text-center text-[#D4A853] font-bold" data-id="element-118">
                      ✅
                    </td>
                  </tr>
                  <tr data-id="element-119">
                    <td className="py-3 px-4 text-[#1B4332]" data-id="element-120">
                      Plan aceleración 21 días
                    </td>
                    <td className="py-3 px-4 text-center" data-id="element-121">❌</td>
                    <td className="py-3 px-4 text-center text-[#D4A853] font-bold" data-id="element-122">
                      ✅
                    </td>
                  </tr>
                  <tr data-id="element-123">
                    <td className="py-3 px-4 text-[#1B4332]" data-id="element-124">
                      Recetas AIR‑FAST exclusivas
                    </td>
                    <td className="py-3 px-4 text-center" data-id="element-125">❌</td>
                    <td className="py-3 px-4 text-center text-[#D4A853] font-bold" data-id="element-126">
                      ✅
                    </td>
                  </tr>
                  <tr data-id="element-127">
                    <td className="py-3 px-4 text-[#1B4332]" data-id="element-128">
                      Guía de hábitos 21 días
                    </td>
                    <td className="py-3 px-4 text-center" data-id="element-129">❌</td>
                    <td className="py-3 px-4 text-center text-[#D4A853] font-bold" data-id="element-130">
                      ✅
                    </td>
                  </tr>
                  <tr className="border-t-2 border-[#D4A853]/30" data-id="element-131">
                    <td className="py-4 px-4 text-[#1B4332] font-bold" data-id="element-132">
                      Precio
                    </td>
                    <td className="py-4 px-4 text-center font-bold text-[#2D5016]" data-id="element-133">
                      16,99€
                    </td>
                    <td className="py-4 px-4 text-center font-bold text-[#D4A853] text-xl" data-id="element-134">
                      23,99€
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="text-lg text-[#2D5016] mt-8 font-medium" data-id="element-135">
              Por solo 7€ más tienes el programa completo de aceleración. La
              diferencia entre empezar bien y empezar rápido.
            </p>
          </div>

          {/* TESTIMONIALS SECTION */}
          <div className="mb-16" data-id="element-136">
            <h3 className="text-3xl md:text-4xl font-bold text-[#1B4332] mb-10" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-137">
              Lo que dicen las personas que ya tienen su MegaPack:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-138">
              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-139">
                <div className="flex gap-1 mb-3" data-id="element-140">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-141">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-142">
                  "Compré el MegaPack un viernes por la noche. El sábado ya
                  estaba cocinando la primera receta. Llevo 5 semanas y he
                  perdido 4 kilos sin pasar hambre. Lo que más me sorprendió es
                  que mi marido y mis hijos comen lo mismo que yo y les
                  encanta."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-143">
                  María G. | Madrid | Ama de casa
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-144">
                <div className="flex gap-1 mb-3" data-id="element-145">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-146">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-147">
                  "Trabajo desde casa y el mayor problema era picar entre horas.
                  Con el plan semanal y los snacks del libro de Postres sin
                  Culpa ya no me levanto a buscar nada al frigorífico. Llevo 6
                  semanas y he perdido 3,5 kilos."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-148">
                  Laura P. | Barcelona | Diseñadora gráfica
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-149">
                <div className="flex gap-1 mb-3" data-id="element-150">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-151">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-152">
                  "Llevo toda mi vida intentando adelgazar y siempre acababa
                  igual. El libro de Sin Efecto Rebote fue lo que cambió todo.
                  Por fin entendí por qué siempre volvía al mismo peso. Llevo 4
                  meses y no he subido ni un gramo."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-153">
                  Roberto M. | Valencia | Comercial
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-154">
                <div className="flex gap-1 mb-3" data-id="element-155">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-156">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-157">
                  "Con los turnos de noche el antojo era mi mayor enemigo. Los
                  postres del libro de Postres sin Culpa me salvaron. Ahora
                  tengo siempre algo rico y saludable preparado."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-158">
                  Carmen T. | Sevilla | Enfermera
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-159">
                <div className="flex gap-1 mb-3" data-id="element-160">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-161">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-162">
                  "En dos meses me he ahorrado más de 80 euros en pedidos a
                  domicilio. El pack se paga solo en la primera semana."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-163">
                  Jorge M. | Bilbao | Ingeniero
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-164">
                <div className="flex gap-1 mb-3" data-id="element-165">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-166">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-167">
                  "Cocino una vez para toda la familia. Mis hijos comen lo mismo
                  que yo y no saben que estoy a dieta. Llevo 7 semanas y he
                  perdido 5 kilos sin que nadie en casa se haya quejado."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-168">
                  Ana T. | Zaragoza | Madre de 3 hijos
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-169">
                <div className="flex gap-1 mb-3" data-id="element-170">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-171">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-172">
                  "Compré el Pack Completo con AIR‑FAST 7 y fue la mejor
                  decisión. Los primeros 21 días me dieron el impulso que
                  necesitaba. Llevo 3 meses y he cambiado completamente mi
                  relación con la comida."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-173">
                  Patricia L. | Málaga | Profesora
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-174">
                <div className="flex gap-1 mb-3" data-id="element-175">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-176">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] mb-3 leading-relaxed" data-id="element-177">
                  "No tengo tiempo para cocinar cada día y el sistema de
                  preparar todo el domingo fue exactamente lo que necesitaba. He
                  perdido 6 kilos en 8 semanas."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-178">
                  David S. | Madrid | Autónomo
                </p>
              </div>
            </div>
          </div>

          {/* GUARANTEE */}
          <div className="max-w-2xl mx-auto mb-16" data-id="element-179">
            <div className="flex justify-center mb-6" data-id="element-180">
              <span className="text-5xl" data-id="element-181">🛡️</span>
            </div>
            <h3 className="text-3xl font-bold text-[#1B4332] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-182">
              GARANTÍA MEGAPACK — 7 DÍAS
            </h3>
            <p className="text-lg text-[#2D5016]/80 mb-4 leading-relaxed" data-id="element-183">
              Abres los 6 libros. Revisas los 3 bonos. Los usas en tu cocina si
              quieres.
            </p>
            <p className="text-lg text-[#2D5016]/80 mb-4 leading-relaxed" data-id="element-184">
              Si en 7 días no es lo que esperabas — te devolvemos el 100%.
            </p>
            <p className="text-2xl font-bold text-[#D4A853] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-185">
              Sin preguntas. Sin formularios. Sin complicaciones.
            </p>
            <p className="text-base text-[#2D5016]/70 leading-relaxed" data-id="element-186">
              La confianza que tenemos en el sistema nos permite ofrecerte esta
              garantía sin dudarlo. Desde el primer día.
            </p>
          </div>
        </FadeInView>
      </div>
    </section>;
}